import * as React from "react";
import * as ReactDOM from "react-dom";
import { FC } from "react";
import { Control } from "ol/control";

const Drawing: FC<{ this: Control; onToggle: CallableFunction }> = (props) => (
    <div className="draw-tools-button" onClick={() => props.onToggle()} title={"Zīmēšana"}>
        <span className="icon-zemesnoma-draw-search" />
    </div>
);

export class DrawingButton extends Control {
    constructor(toggleDrawingMenu: CallableFunction) {
        const element = document.createElement("div");
        element.className = "pubevents-map-button draw-container ol-unselectable ol-control";
        super({
            element
        });
        ReactDOM.render(<Drawing this={this} onToggle={toggleDrawingMenu} />, element);
    }
}
